import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getHeaders, getUrl } from '../../../api/api'
import {  signOut } from '../../../utils/authentication'

export const logout = createAsyncThunk<void, void, ThunkConfig<string>>(
    'authentication/logout',
    async (_, thunkAPI) => {
        const { rejectWithValue } = thunkAPI

        // make API call to end session on backend side
        try {
            await fetch(getUrl(`/oauth/logout`), {
                method: 'DELETE',
                headers: getHeaders({
                    'Content-Type': 'application/json',
                }),
            })
        } catch (e) {
            console.error('There was an error on logout request', e)
            return rejectWithValue('There was an error on logout request')
        } finally {
            signOut()
        }
    }
)
